<emm-management-layout>
    <emm-progress-bar [isLoading$]="anyLoading$"></emm-progress-bar>
    <emm-search-filter
        [addDialog]="true"
        [attr.data-testid]="'consumer_type_search_bar'"
        [displaySearchWithOptions]="false"
        [fields]="fields"
        [isAdminOrAuthor]="this.isAdmin || this.isAuthor"
        [isSuperAdmin]="this.isSuperAdmin"
        layout-center-header
        (add)="openCreateConsumerTypeDialog()"
        (filter)="onFilter($event)"
    ></emm-search-filter>
    <emm-generic-items-list
        [contextMenuActions]="consumerTypesContextMenuActions"
        [isReadOnly]="isReadOnly$ | async"
        [items]="consumerTypes$ | async"
        layout-center-content
        (onSelectItem)="onSelectConsumerType($event)"
    ></emm-generic-items-list>
    <emm-management-attributes-header
        *ngIf="selectedConsumerType$ | async as item"
        layout-right-header
        [name]="item.name"
        [tag]="item.tag"
    ></emm-management-attributes-header>
</emm-management-layout>
